(() => {
  const SELECTOR = 'video.product-media__lazy-video';

  if (window.GoldylostProductVideoLazyload) {
    window.GoldylostProductVideoLazyload.refresh();
    return;
  }

  const observedVideos = new WeakSet();
  const preparedVideos = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  const shouldAvoidAutoplay = () => reduceMotion.matches || connection?.saveData === true;

  const isVisible = video => {
    if (!video.isConnected || !video.getClientRects().length) return false;

    const styles = window.getComputedStyle(video);
    if (styles.display === 'none' || styles.visibility === 'hidden') return false;

    const slide = video.closest('.swiper-slide');
    const slider = slide?.closest('swiper-product-gallery, product-media, [data-slider]');
    const activeSlide = slider?.querySelector('.swiper-slide-active');

    return !activeSlide || slide === activeSlide;
  };

  const prepare = video => {
    if (preparedVideos.has(video)) return;

    preparedVideos.add(video);
    video.preload = 'metadata';
    video.load();
  };

  const pause = video => {
    if (!video.paused) video.pause();
  };

  const play = video => {
    if (!isVisible(video)) return;

    if (shouldAvoidAutoplay()) {
      video.controls = true;
      pause(video);
      return;
    }

    const scope = video.closest('[data-main-product], .main-product__media, product-media') || document;
    scope.querySelectorAll(SELECTOR).forEach(otherVideo => {
      if (otherVideo !== video) pause(otherVideo);
    });

    prepare(video);
    video.muted = true;
    video.playsInline = true;

    const playPromise = video.play();
    if (playPromise !== undefined) playPromise.catch(() => pause(video));
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
        play(entry.target);
      } else {
        pause(entry.target);
      }
    });
  }, {
    threshold: [0, 0.35, 0.7]
  });

  const observe = video => {
    if (observedVideos.has(video)) return;

    observedVideos.add(video);
    video.autoplay = false;
    video.preload = 'none';

    if (shouldAvoidAutoplay()) video.controls = true;

    video.addEventListener('pointerdown', () => prepare(video), { passive: true });
    observer.observe(video);
  };

  const refresh = root => {
    const searchRoot = root?.querySelectorAll ? root : document;
    if (searchRoot.matches?.(SELECTOR)) observe(searchRoot);
    searchRoot.querySelectorAll(SELECTOR).forEach(observe);
  };

  const pauseAll = () => document.querySelectorAll(SELECTOR).forEach(pause);

  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) refresh(node);
      });
    });
  });

  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) pauseAll();
    else refresh();
  });
  document.addEventListener('shopify:section:load', event => refresh(event.target));

  window.GoldylostProductVideoLazyload = { refresh, pauseAll };
  refresh();
})();
